export default __webpack_public_path__ + "static/media/icon_create_active.f71d5afc.svg";